import { render, staticRenderFns } from "./softwareCompany.vue?vue&type=template&id=75dc4d1a&scoped=true&"
import script from "./softwareCompany.vue?vue&type=script&lang=js&"
export * from "./softwareCompany.vue?vue&type=script&lang=js&"
import style0 from "./softwareCompany.vue?vue&type=style&index=0&id=75dc4d1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dc4d1a",
  null
  
)

export default component.exports